import { GuideStatus } from 'app/components/GuideStatus';

const GuideStatusPage = () => {
  return <GuideStatus />;
};

export default GuideStatusPage;
